export default "__VITE_ASSET__D7W5QL9G__"